import React from 'react';

import type { Timeline } from '../../types/timeline';

const TimelineAuthor: React.FC<{ timeline: Timeline }> = ({ timeline }) => {
  return (
    <div className="timeline-author wa-cluster wa-gap-xs">
      <div>
        <wa-avatar initials={timeline.user.initials} style={{ '--size': '28px' }} />
      </div>
      <div>
        Created and shared by {timeline.user.name}
      </div>
    </div>
  );
}

export default TimelineAuthor;
